import { Chip, type ChipSize } from '@/components/ui'
import type { QuoteStatus } from '../api/types'
import { LABEL_BY_STATUS, VARIANT_BY_STATUS } from './quoteStatusMeta'

/**
 * Module-scoped status chip for quotes (Sprint 12c labels). The
 * variant/label maps live in `quoteStatusMeta.ts` so non-component
 * consumers (the group-by-status logic) can share them.
 */

export interface QuoteStatusChipProps {
  status: QuoteStatus
  size?: ChipSize
}

export function QuoteStatusChip({ status, size = 'xs' }: QuoteStatusChipProps) {
  return (
    <Chip variant={VARIANT_BY_STATUS[status]} size={size} dot>
      {LABEL_BY_STATUS[status]}
    </Chip>
  )
}

/** Re-exported so consumers (Kanban stages, filter rail) can match
 *  labels without a separate constant. */
export const QUOTE_STATUS_LABELS = LABEL_BY_STATUS
